import React from 'react';
import { Link } from 'react-router-dom';

const Projects = () => {
    const projects = [
      {
        img: "https://i.ibb.co/Wvxjqy5/power-tools-img.png",
        icon: "Power Tools",
        name: "Power Tools",
        details:
          "Responsive design implemented with tailwind css.Authenticated with firebase using react firebase hooks. Applied admin panel and authorization.Aggregated protected route for order, payment and approve (admin) using react router.Applied Card payment system with stripe.",
        link: "https://power-tools-b56dd.web.app/",
      },
      {
        img: "https://i.ibb.co/VN597BR/book-verse-img.png",
        icon: "BookVerse",
        name: "BookVerse",
        details:
          "Responsive design implemented with React Bootstrap.Authenticated with firebase using react firebase hooks. Added managing system for products and orders.Applied protected route for order, payment and approve (admin) using react router",
        link: "https://book-verse-8b615.web.app/",
      },
      {
        img: "https://i.ibb.co/Gv5ndqy/do-be-done-img.png",
        icon: "Power Tools",
        name: "DoBeDone",
        details:
          "Responsive design implemented with React Bootstrap.Implemented task adding and deleting system using React State.Integrated a task completion feature which shows the completed tasks differently.",
        link: "https://do-be-done-final.web.app/",
      },
      {
        img: "https://i.ibb.co/FY973R1/1717751049002.jpg",
        icon: "Waste Not",
        name: "Waste Not",
        details:
          "This is my latest full stack project. Featuring my knowledge in React.js, Node.js, Express.js, MongoDB, CRUD operations, and JWT authentication",
        link: "https://waste-not-f415a.web.app/",
      },
    ];
    return (
      <div id="projects">
        <h1 className="my-10 text-5xl font-semibold">My Projects</h1>
        <div className="flex flex-wrap justify-around mt-10 mb-10">
          {projects.map((project, index) => (
            <div key={index} className="card w-96 shadow-xl image-full my-4">
              <figure className="hero-overlay  ">
                <img src={project.img} alt="Shoes" />
              </figure>
              <div className="card-body">
                <h2 className="text-yellow-300 card-title">{project.name}</h2>
                <p className=" bg-black bg-opacity-30 rounded-lg text-white">
                  {project.details}
                </p>
                <div className="card-actions justify-between text-yellow-400 ">
                  <Link
                    to={`project${index + 1}`}
                    target="blank"
                    className="btn  btn-outline"
                  >
                    Details
                  </Link>
                  <a
                    href={project.link}
                    target="blank"
                    className="btn  btn-outline"
                  >
                    Visit Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
};

export default Projects;